import { render, staticRenderFns } from "./AuthRules.vue?vue&type=template&id=74d1d552&scoped=true"
import script from "./AuthRules.vue?vue&type=script&lang=js"
export * from "./AuthRules.vue?vue&type=script&lang=js"
import style0 from "./AuthRules.vue?vue&type=style&index=0&id=74d1d552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d1d552",
  null
  
)

export default component.exports